export default __webpack_public_path__ + "static/media/Trident Limited .a78f653a.jpg";